import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AttendanceUser } from '../../sessions/session/attendance/attendance-ui-models';
import { AttendanceStatusMode } from '../attendance-status-indicator/attendance-status-indicator.component';
import { PencilModalSizeEnum } from '../../standalones/components/modals/modal-template/modal-template.component';

@Component({
  selector: 'app-attendance-notes',
  templateUrl: './attendance-notes.component.html',
  styleUrls: ['./attendance-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttendanceNotesComponent implements OnInit {
  public attendanceUser!: AttendanceUser;
  public updatedNotes?: string;
  public readonly NOTE_MAX_LENGTH = 500;

  eventId = '';
  isViewMode = false;

  readonly AttendanceStatusMode = AttendanceStatusMode;
  readonly PencilModalSizeEnum = PencilModalSizeEnum;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    @Optional() private dialogRef: MatDialogRef<AttendanceNotesComponent>,
  ) {}

  ngOnInit(): void {
    this.attendanceUser = this.data.user;
    // Initialize notes with an empty string if it's null or undefined
    // This ensures that we always have a defined string value to work with,
    // This will help when checking disabled state for the done button
    this.attendanceUser.notes ??= '';
    this.eventId = this.data.eventId;
    this.updatedNotes = this.attendanceUser.notes;
    this.isViewMode = this.data.isViewMode;
  }

  doneClick() {
    this.dialogRef.close(this.updatedNotes);
  }

  cancelClick() {
    this.dialogRef.close(undefined);
  }
}
